import AdminTemplatesGate from "#/admin/templates/components/AdminTemplatesGate";
import MessageTemplatesLayout from "#/message-templates/components/MessageTemplatesLayout";

export default function AdminTemplatesPage() {
  return (
    <AdminTemplatesGate>
      <MessageTemplatesLayout />
    </AdminTemplatesGate>
  );
}
